export const  defaultSelectedDateUp  = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const day = currentDate.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const defaultSelectedDateFrom = () => {
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    const year = oneMonthAgo.getFullYear();
    const month = (oneMonthAgo.getMonth() + 1).toString().padStart(2, '0');
    const day = oneMonthAgo.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;

};

export default {
    loading: {
        module: false
    },
    params: {
        branch_office_id: null,
        branch_office_warehouse_id: null,
        branch_office_id_out:Number(localStorage.selected_branchoffice),
        branch_office_warehouse_id_out:null,
        date_from : defaultSelectedDateFrom() ,
        date_up : defaultSelectedDateUp()
    },
    branchOffices: [],
    branchoffice_warehouses: [],

    branchOffices_out: [],
    branchoffice_warehouses_out: [],

    reportTransfer: [],
    documents_products: [],
    lines: [],
    brands: [],
    ag_grid:{
        selectedTheme:'ag-theme-balham'
    }
}



// WEBPACK FOOTER //
// ./src/modules/report-transfers/state.js